import React from 'react'
import { useAppSelector } from '../store/store'
import { useAuthNavigation } from '../hooks/useAuthActions'
import { eventHandler } from '../types.d'

export type InjectedFrameProps = {
  loading: boolean
  error: string | null
  onPreviousStep?: eventHandler
  recaptchaSiteKey?: string | null
  logoUrl?: string | null
}

export function withFrameProps<P>(
  WrappedComponent: React.ComponentType<P>,
  { hasPreviousStep = false },
) {
  return function WithFrameProps(props: Omit<P, keyof InjectedFrameProps>) {
    const loading = useAppSelector((state) => state.auth.loading)
    const error = useAppSelector((state) => state.auth.error)
    const baseRecaptchaSiteKey = useAppSelector(
      (state) => state.auth.config.recaptchaSiteKey,
    )
    const captchaBypass = useAppSelector(
      (state) => state.auth.config.captchaBypass,
    )
    const logoUrl = useAppSelector((state) => state.auth.config.logoUrl)

    // Disable recaptcha when bypass flag is set
    const recaptchaSiteKey = captchaBypass ? null : baseRecaptchaSiteKey
    const { previousStep } = useAuthNavigation()

    const injectedFrameProps: InjectedFrameProps = {
      loading,
      error,
      recaptchaSiteKey,
      logoUrl,
    }

    if (hasPreviousStep) {
      injectedFrameProps.onPreviousStep = previousStep
    }

    return <WrappedComponent {...(props as P)} {...injectedFrameProps} />
  }
}
